import Experience from "../../components/Experience/Experience";
import AboutUsHelmetComponent from "./AboutUsHelmetComponent";
import Team from "../../components/Team/Team";
import Stage from "../../assets/new_logo.webp";

const AboutUs = () => {
  return (
    <div className="w-full pt-10 pb-16">
      <AboutUsHelmetComponent />

      <div className="dark:bg-black dark:bg-opacity-35 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-10 pb-8">
        {/* 1) Otsikko ja johdanto-teksti */}
        <div className="text-center mb-14">
        <h1
          className="font-customFont2 dark:text-shadow-xxl text-darkest dark:text-primary text-5xl sm:text-6xl lg:text-6xl font-bold leading-tight mb-4"
          data-aos="fade-in" data-aos-duration="2000"
        >
          Spiderlegs Productions
        </h1>

        <p
          className="font-customFont1 dark:text-shadow-lg text-darkest dark:text-primary text-xl sm:text-2xl font-light mx-auto max-w-3xl"
          data-aos="fade-up" data-aos-duration="2500"
        >
          <strong>Keravalla</strong> toimiva monipuolinen tapahtumapalveluiden tarjoaja, 
          joka hoitaa niin äänentoiston ja esitystekniikan kuin 
          suoraan buukattavat bändit ja esiintyjät.
        </p>

        </div>

        {/* 2) Kaksi palstaa: teksti vasen, kuva oikea */}
        <div className="grid grid-cols-1 xsm:grid-cols-1 sm:grid-cols-2 md:grid-cols-2 mdd:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-2 gap-10 items-center">
          {/* Teksti vasemmalla */}
          <div className="flex flex-col p-6 bg-white bg-opacity-80 dark:bg-violet dark:bg-opacity-80">
            <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-lg text-lg sm:text-lg md:text-lg lg:text-lg xl:text-xl 1xl:text-1xl font-light">
              <strong>Spiderlegs Productions</strong> on Keravalla sijaitseva 
              monipuolinen tapahtumapalveluiden tarjoaja. 
              Toiminta-alueemme kattaa pääasiassa Etelä-Suomen, ja 
              tarjoamme palveluja häihin, yritysjuhliin, teemabileisiin 
              sekä muihin tilaisuuksiin.
            </p>
            <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-lg text-lg sm:text-lg md:text-lg lg:text-lg xl:text-xl 1xl:text-1xl font-light mt-4">
              Meiltä saat kokonaisvaltaiset ratkaisut tapahtumasi järjestämiseen – 
              olipa kyseessä äänentoisto- ja tunnelmavalaistusratkaisut tai 
              suoraan buukattavat bändit ja esiintyjät. Tarjoamme 
              kilpailukykyiset hinnat, räätälöidyt ratkaisut ja joustavat 
              palvelut, jotta sinun ei tarvitse huolehtia järjestelyistä.
            </p>
            <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-lg text-lg sm:text-lg md:text-lg lg:text-lg xl:text-xl 1xl:text-1xl font-light mt-4">
              Palveluihimme kuuluu lisäksi edullinen kuljetus- ja asennuspalvelu, 
              maksuton opastus laitteiden käyttöön sekä mahdollisuus varata 
              suoraan bändejä ja esiintyjiä. Voit keskittyä nauttimaan 
              tapahtumastasi – me huolehdimme lopusta.
            </p>
          </div>

          {/* Kuvaboxi oikealla */}
          <div className="relative h-full w-full overflow-hidden flex justify-center items-center">
            <img
              src={Stage}
              alt="Stage setup"
              className="object-cover scale-75"
            />
          </div>
        </div>

        {/* 3) Tiimi */}
        <section className="mt-1">
          <Team />
        </section>

        {/* 4) Kokemus / referenssit */}
        <section className="mt-1">
          <Experience />
        </section>
      </div>
    </div>
  );
};

export default AboutUs;
